import React from 'react';
import { Linkedin, Twitter, Facebook, MapPin, Phone, Mail } from 'lucide-react';
import { navigateToHomeSection } from '../utils/navigation';
import { companyInfo, socialLinks } from '../data/mock';
import { siteConfig } from '../config/site';

const Footer = () => {
  const mapsLink =
    'https://www.google.com/maps/search/?api=1&query=' +
    encodeURIComponent(companyInfo.branches?.[0]?.address || companyInfo.address);

  return (
    <footer id="contact" className="bg-black border-t border-blue-500/20 py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-11 h-11 rounded-lg bg-white/10 border border-white/10 backdrop-blur-sm flex items-center justify-center p-1.5">
                <img
                  src={siteConfig.footerLogoUrl}
                  alt="Smart Automation logo"
                  className="w-full h-full object-contain"
                  loading="lazy"
                />
              </div>
              <div>
                <h3 className="text-lg font-bold">{siteConfig.companyShortName}</h3>
                <p className="text-xs text-blue-400"></p>
              </div>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Leading provider of smart home automation and low voltage infrastructure solutions with 15+ years of excellence.
            </p>
            <div className="flex space-x-4">
              <a href={socialLinks.linkedin} target="_blank" rel="noreferrer" className="w-10 h-10 bg-blue-500/10 hover:bg-blue-500/20 border border-blue-500/30 rounded-lg flex items-center justify-center transition-all duration-300">
                <Linkedin className="w-5 h-5 text-blue-400" />
              </a>
              <a href={socialLinks.twitter} target="_blank" rel="noreferrer" className="w-10 h-10 bg-blue-500/10 hover:bg-blue-500/20 border border-blue-500/30 rounded-lg flex items-center justify-center transition-all duration-300">
                <Twitter className="w-5 h-5 text-blue-400" />
              </a>
              <a href={socialLinks.facebook} target="_blank" rel="noreferrer" className="w-10 h-10 bg-blue-500/10 hover:bg-blue-500/20 border border-blue-500/30 rounded-lg flex items-center justify-center transition-all duration-300">
                <Facebook className="w-5 h-5 text-blue-400" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-2">
              <li><button type="button" onClick={() => navigateToHomeSection('services')} className="bg-transparent text-gray-400 hover:text-blue-400 transition-colors">Services</button></li>
              <li><button type="button" onClick={() => navigateToHomeSection('projects')} className="bg-transparent text-gray-400 hover:text-blue-400 transition-colors">Projects</button></li>
              <li><button type="button" onClick={() => navigateToHomeSection('about')} className="bg-transparent text-gray-400 hover:text-blue-400 transition-colors">About Us</button></li>
              <li><button type="button" onClick={() => navigateToHomeSection('contact')} className="bg-transparent text-gray-400 hover:text-blue-400 transition-colors">Contact</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 text-white">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-gray-400">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <a
                  href={mapsLink}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm transition-colors duration-300 hover:text-blue-300"
                >
                  Ahmedabad, Vadodara &amp; Anand<br />Gujarat, India
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Phone className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <span className="text-sm">{companyInfo.phone}</span>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Mail className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <span className="text-sm">{companyInfo.email}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-blue-500/20 pt-6 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Smart Automation &amp; LV Systems Pvt Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
